module.exports = __webpack_public_path__ + "assets/videos/green-xmas-poster-image-desktop.jpg?v=d6670fa4";